import React from 'react';
import { useCart } from 'react-use-cart';

import { Icon } from '@iconify/react';
import Close from '@iconify/icons-mdi/close';

import trackEvent from '~/hooks/useEventTracker';

const RemoveItemButton = ({ cartItem }) => {
	const { removeItem } = useCart();

	return (
		<button
			type="button"
			className="absolute top-0 right-0 bg-button-removeItem-background-default text-button-removeItem-color rounded-full p-px translate-x-1/2 -translate-y-1/2 transition-colors hover:bg-button-removeItem-background-hover focus:bg-button-removeItem-background-hover"
			title="Remove item from cart"
			onClick={() => {
				removeItem(cartItem.id);
				trackEvent('Cart', 'Remove Item', cartItem.sku);
			}}
		>
			<span className="sr-only">Remove item</span>
			<Icon icon={Close} height="1rem" width="1rem" className="w-3.5 h-3.5" />
		</button>
	);
};

export default RemoveItemButton;
